<template>
  <div id="app">
    <!-- This forces Vue to reload a component when the route changes. -->
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style src="./assets/global.css"></style>
